import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { businessTimeZone } from "../../utils/date"


export const getAllHistories = createAsyncThunk('history/getAllHistories', async ({
  userId,
  limit,
  offset,
  filters,
  sortField,
  sortOrder,
}, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/history`, {
      params: {
        limit,
        offset,
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
        sortField: sortField || undefined,
        sortOrder: sortOrder || undefined,
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getAllHistoriesByUserId = createAsyncThunk('history/getAllHistoriesByUserId', async ({
  userId,
  limit,
  offset,
  filters,
  sortField,
  sortOrder,
}, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/history/users/${userId}`, {
      params: {
        limit,
        offset,
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
        sortField: sortField || undefined,
        sortOrder: sortOrder || undefined,
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getHistoryForFilterUtils = createAsyncThunk('user/getHistoryForFilterUtils', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/history/filters/utils')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contact-groups'
    return rejectWithValue(errorMessage)
  }
})

export const getHistoryCreatorsForFilterUtils = createAsyncThunk(
  'history/getHistoryCreatorsForFilterUtils',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/history/creators/filters/utils')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || error.message
      return rejectWithValue(errorMessage)
    }
  }
)

export const getHistoryCSV = createAsyncThunk("history/getHistoryCSV", async ({ filters }, thunkAPI) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))
    return await apiRequest.get("/history/export", {
      params: {
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
      }
    })
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message)
  }
})

export const downloadHistoryCSV = createAsyncThunk("history/downloadHistoryCSV", async ({ filters }, thunkAPI) => {
  try {
    const response = await thunkAPI.dispatch(getHistoryCSV({ filters }))
    const base64Data = response?.payload?.data?.data
    if (!base64Data) {
      throw new Error('No data received')
    }

    const dataUri = base64Data.startsWith('data:text/csv;base64,')
      ? base64Data
      : 'data:text/csv;base64,' + base64Data

    const link = document.createElement('a')
    link.href = dataUri
    link.download = 'history_export.csv'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message)
  }
})